module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/linea-etica-en/cabecera.jpg
// module id = w7kl
// module chunks = 0